var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.0934 20.6508C26.0079 20.7505 25.9036 20.8325 25.7864 20.8919C25.6692 20.9513 25.5414 20.9871 25.4104 20.9971C25.2794 21.0071 25.1477 20.9912 25.0229 20.9503C24.898 20.9094 24.7824 20.8443 24.6827 20.7588L16.0001 13.3174L7.31739 20.7588C7.11495 20.9213 6.85726 20.9987 6.59879 20.9746C6.34032 20.9506 6.10133 20.827 5.93234 20.6299C5.76335 20.4329 5.6776 20.1778 5.69322 19.9187C5.70884 19.6596 5.82461 19.4167 6.01605 19.2414L15.3494 11.2414C15.5306 11.0861 15.7614 11.0008 16.0001 11.0008C16.2387 11.0008 16.4695 11.0861 16.6507 11.2414L25.9841 19.2414C26.1851 19.4141 26.3095 19.6595 26.3297 19.9237C26.35 20.188 26.2645 20.4495 26.0921 20.6508","fill":"currentColor"}));
}

ArrowUp.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
